module.exports = __webpack_public_path__ + "img/qr.6c29439f.png";